import { render, staticRenderFns } from "./AppTeamMembersEdit.vue?vue&type=template&id=53ca094d"
import script from "./AppTeamMembersEdit.vue?vue&type=script&lang=js"
export * from "./AppTeamMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./AppTeamMembersEdit.vue?vue&type=style&index=0&id=53ca094d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports